import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper, { PageCard, PageTitle, SectionH2, Para } from '../../components/Layout/PageWrapper';

function Dmca() {
  return (
    <PageWrapper>
      <Helmet>
        <title>DMCA Notice | TheGameZone</title>
        <meta name="description" content="TheGameZone DMCA policy. Report copyright infringement here." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://thegamezone.fun/DMCA" />
      </Helmet>
      <PageCard>
        <PageTitle>DMCA Notice</PageTitle>
        <SectionH2>Copyright Notice</SectionH2>
        <Para>At TheGameZone, we respect the intellectual property rights of others. If you believe any content on our website infringes your copyright, please contact us immediately.</Para>
        <SectionH2>Filing a DMCA Takedown Request</SectionH2>
        <Para>To report copyright infringement, email us at info@thegamezone.fun with the subject "DMCA Takedown Request".</Para>
        <Para>Your notice must include: a description of the copyrighted work, the URL where the infringing content is located, your contact information, and a statement of good faith belief.</Para>
        <SectionH2>Counter-Notice</SectionH2>
        <Para>If you believe content was removed in error, you may file a counter-notice by sending an email to info@thegamezone.fun.</Para>
        <SectionH2>Repeat Infringers</SectionH2>
        <Para>TheGameZone will terminate accounts of users who repeatedly infringe on copyright in appropriate circumstances.</Para>
        <SectionH2>Contact Information</SectionH2>
        <Para>For DMCA notices or questions, email: info@thegamezone.fun</Para>
      </PageCard>
    </PageWrapper>
  );
}

export default Dmca;
